import {
  Component,
  HostListener,
  output,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { ReactiveFormsModule, FormControl, Validators } from '@angular/forms';

import { FormComponent } from '@classes/form';

export interface SearchItem {
  title: string;
  link?: string;
}

@Component({
  selector: 'app-search-bar',
  imports: [ReactiveFormsModule],
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.scss'],
})
export class SearchBarComponent extends FormComponent {
  @ViewChild('searchInput') searchInput!: ElementRef<HTMLInputElement>;

  close = output<void>();
  onSearch = output<string>();

  override form = this.formBuilder.group({
    query: new FormControl(''),
  });

  ngAfterViewInit(): void {
    setTimeout(() => this.searchInput.nativeElement.focus(), 50);
  }

  @HostListener('document:keydown.escape', ['$event'])
  onEscapeKey(event: Event): void {
    event.preventDefault();
    event.stopPropagation();

    this.close.emit();
  }

  onBackdropClick(event: MouseEvent): void {
    const card = (event.target as HTMLElement).closest('.cmdk-card');

    if (!card) {
      this.close.emit();
    }
  }

  search(): void {
    if (this.form.invalid) return;

    this.onSearch.emit(this.form.get('query')?.value ?? '');
  }
}
